/**
 * This file was auto-generated by Fern from our API Definition.
 */
import { Config } from "../resources/config/client/Client";
export class Deprecated {
    constructor(_options = {}) {
        this._options = _options;
    }
    get config() {
        return (this._config ?? (this._config = new Config(this._options)));
    }
}
